export var wrapAudioBufferSourceNodeStartMethodDurationParameter = function wrapAudioBufferSourceNodeStartMethodDurationParameter(nativeAudioScheduledSourceNode, nativeContext) {
  var endTime = Number.POSITIVE_INFINITY;
  var stopTime = Number.POSITIVE_INFINITY;

  nativeAudioScheduledSourceNode.start = function (start, stop) {
    return function () {
      var when = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Number.POSITIVE_INFINITY;
      start.call(nativeAudioScheduledSourceNode, when, offset);

      if (duration >= 0 && duration < Number.POSITIVE_INFINITY) {
        var actualStartTime = Math.max(when, nativeContext.currentTime); // @todo The playbackRate could of course also have been automated and is not always fixed.

        var durationInBufferTime = duration / nativeAudioScheduledSourceNode.playbackRate.value;
        endTime = actualStartTime + durationInBufferTime;
        stop.call(nativeAudioScheduledSourceNode, Math.min(endTime, stopTime));
      }
    };
  }(nativeAudioScheduledSourceNode.start, nativeAudioScheduledSourceNode.stop);

  nativeAudioScheduledSourceNode.stop = function (stop) {
    return function () {
      var when = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      stopTime = Math.max(when, nativeContext.currentTime);
      stop.call(nativeAudioScheduledSourceNode, Math.min(endTime, stopTime));
    };
  }(nativeAudioScheduledSourceNode.stop);
};